<template>
  <div class="pravo-sirsi">
    <div
      v-if="lobbyMe.isOwner"
      style="margin: 1rem 1rem 0"
      @click="startGame"
      class="button finalScreen__center__button__leave"
    >
      Start game
    </div>


    <Control />
    <Search />
    <Teams />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Control from "@/components/lobby/pravo/Control.vue";
import Search from "@/components/lobby/pravo/Search.vue";
import Teams from "@/components/lobby/pravo/Teams.vue";

export default {
  name: "LobbyOverview",
  data() {
    return {
      teamName: "",
      isLoading: false,
    };
  },
  components: {
    Control,
    Search,
    Teams,
  },
  computed: {
    ...mapGetters(["lobbyMe", "me"]),
  },
  async mounted() {
    await this.$store.dispatch("fetchLobby");
  },
  methods: {
    async startGame() {
      await this.$store.dispatch("startGame");
    },
  },
};
</script>
